enum CashFlowType {
  INFLOW = 'INFLOW',
  OUTFLOW = 'OUTFLOW',
}

export default CashFlowType;
